import AssistClasses from './AssistClasses.js'
import formats from '../../api/formats'

class ContractorCheckSelectContractor extends AssistClasses.Step {
  constructor (cxt) {
    super('Выберите контрагента',
      (step) => {
        return `${step.formatField('contractorInn' + 'DESCRIPTION')} Инн: ${step.formatField('contractorInn')}`
      },
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Инн контрагента',
            name: 'contractorInn',
            persistentHint: true,
            hint: (model, field) => {
              var result = model[field.name + 'DESCRIPTION']
              if (result) {
                return result
              }
              return 'Введите ИНН или выберите контрагента'
            },
            grow: true,
            size: {sm8: true, xs6: true}
          },
          {
            fieldType: 'v-btn',
            slot: 'Выбрать',
            events: {'click': () => cxt.selectCompany('contractorInn')},
            shrink: true,
            size: {sm4: true, xs6: true}
          }
        ]
      },
      {
        contractorInn: null
      }
    )
    this.context = cxt
    this.editable = true
    this.nextEnabled = () => this.model['contractorInn']
  }
}

class ContractorCheckLoadDocuments extends AssistClasses.Step {
  constructor (cxt) {
    super(
      'Загрузите в депозитарий документы, полученные от контрагента или выберите из депозитария',
      null,
      {
        scheme: []
      },
      {
        fileList: null
      })
    this.context = cxt
    this.editable = true
    this.items = []
  }
  fillFields () {
    var lScheme = []
    var cxt = this.context
    lScheme.push({
      fieldType: 'v-chips-field',
      label: 'Список документов ',
      name: 'fileList',
      events: {
        'change': () => this.onListChange(),
        'remove': (key) => this.onRemove('fileList', key)
      },
      chipSize: 10,
      items: (model, field) => {
        return this.items
      },
      size: {sm12: true, xs12: true}
    })
    lScheme.push({
      fieldType: 'v-btn',
      slot: 'Загрузить',
      events: {'click': () => cxt.loadDocs('fileList', 'depoFolder')},
      size: {sm4: true, xs6: true},
      shrink: false
    })
    lScheme.push({
      fieldType: 'v-btn',
      slot: 'Выбрать',
      events: {'click': () => cxt.attachDocs('fileList',
        {path: this.model['depoFolder'].toString(), inns: [this.model['contractorInn_CODE'].toString()]}
        )},
      size: {sm4: true, xs6: true},
      shrink: false
    })
    this.props.scheme = lScheme
    return this
  }
  onListChange () {
    const getHint = file => {
      return `${file.docName} (UID: ${file.uid})`
    }
    const getError = files => null
    const cb = (files) => {
      let set = new Set(uids)
      let items = files.map(c => {
        set.delete(c.uid.toString())
        return {value: c.uid.toString(), text: c.docName, hint: getHint(c), error: getError(c)}
      })
      this.items = items.sort((a, b) => formats.compareString(a.text, b.text))
    }
    let uids = formats.splitDepoUids(this.model['fileList'])
    this.context.getDepoFileProps(uids, cb)
  }
  onRemove (fieldname, key) {
    let uids = formats.splitDepoUids(this.model[fieldname])
    uids = uids.filter(uid => uid !== key)
    this.model[fieldname] = uids.join(', ')
  }
}

class ContractorCheckAttachDocuments extends AssistClasses.Step {
  constructor (cxt) {
    super('Проверьте автоматическую классифиакцию документов',
      (step) => {
        return this.fillSubTitle(step.model, step.props.scheme)
      },
      {
        scheme: []
      },
      {
      })
    this.context = cxt
    this.editable = true
    this.items = []
  }
  fillSubTitle (model, fields) {
    this.onListChange()
    var result = []
    fields.forEach(f => {
      if (/depo/i.test(f.defValue)) {
        let uids = model[f.name]
        formats.splitDepoUids(uids).forEach(uid =>
          result.push(`<a href="${this.context.getDepoUrl(uid).concat('/stream')}" target="_blank">Открыть ${f.label}</a>`)
        )
      }
    })
    return result.join('<br/>')
  }
  fillFields (fields) {
    if (!fields) {
      this.props.scheme = []
      return this
    }
    const persistentHint = true
    var lScheme = []
    var model = {}
    var cxt = this.context
    fields.forEach(f => {
      if (/depo/i.test(f.value)) {
        model[f.name + 'Uid'] = null
        switch (f.type) {
          case 'text':
            lScheme.push({
              fieldType: 'v-chips-field',
              emptyChip: 'Добавить',
              label: f.label,
              name: f.name + 'Uid',
              defValue: f.value,
              events: {
                'click': () => cxt.selectDocs(f.name + 'Uid', this.items, f.label),
                'remove': (key) => this.onRemove(f.name + 'Uid', key)
              },
              chipSize: 30,
              items: (model, field) => {
                let uids = model[f.name + 'Uid'] || ''
                // console.log('items', uids)
                return this.items.filter(item => uids.includes(item.value))
              },
              size: {sm12: true, xs12: true}
            })
            break
          case 'textarea': lScheme.push({
            fieldType: 'v-textarea',
            label: f.label,
            hint: f.hint,
            persistentHint: persistentHint,
            name: f.name,
            rows: f.rows > 0 ? f.rows : 1,
            size: {sm12: true, xs12: true}
          })
            break
        }
      }
    })
    this.props.scheme = lScheme
    this.setModel(model)
    return this
  }
  onListChange () {
    const getHint = file => {
      return `${file.docName} (UID: ${file.uid})`
    }
    const getError = files => null
    const cb = (files) => {
      let set = new Set(uids)
      let items = files.map(c => {
        set.delete(c.uid.toString())
        return {value: c.uid.toString(), text: c.docName, hint: getHint(c), error: getError(c)}
      })
      this.items = items.sort((a, b) => formats.compareString(a.text, b.text))
    }
    let uids = formats.splitDepoUids(this.model['fileList'])
    this.context.getDepoFileProps(uids, cb)
  }
  onRemove (fieldname, key) {
    let uids = formats.splitDepoUids(this.model[fieldname])
    uids = uids.filter(uid => uid !== key)
    this.model[fieldname] = uids.join(', ')
  }
}

class ContractorCheckConfirmation extends AssistClasses.Step {
  constructor (cxt) {
    super('Сделайте заключение',
      (step) => {
        return this.fillSubTitle(step.model, step.props.scheme)
      },
      {
        scheme: []
      },
      {
      })
    this.context = cxt
    this.editable = true
  }
  fillSubTitle (model, fields) {
    return model['zakluchenieOProverke']
  }
  fillFields (fields) {
    if (!fields) {
      this.props.scheme = []
      return this
    }
    const persistentHint = true
    var lScheme = []
    fields.forEach(f => {
      if (/depo/i.test(f.value) === false) {
        switch (f.type) {
          case 'text':
          case 'textarea': lScheme.push({
            fieldType: 'v-textarea',
            label: f.label,
            hint: f.hint,
            persistentHint: persistentHint,
            name: f.name,
            rows: f.rows > 0 ? f.rows : 1,
            size: {sm12: true, xs12: true}
          })
            break
        }
      }
    })
    this.props.scheme = lScheme
    return this
  }
  next (model, cb) {
    delete model.depoLink
    return cb(model)
  }
}

class DocumnentCheck extends AssistClasses.Step {
  constructor (cxt) {
    super(
      'Для завершения проверки поместите результат в депозитарий',
      (step) => {
        return this.fillSubTitle(step.model, step.props.scheme)
      },
      {
        scheme: [
          {
            fieldType: 'v-flex',
            slot: 'Документ будет создан и помещен в депозитарий',
            shrink: false,
            size: {sm6: true, xs6: true},
            if: (model, field) => (model['depoLinkAction'] == null) && (model['depoLink'] == null)
          },
          {
            fieldType: 'v-btn',
            slot: 'Подготовить',
            events: {'click': () => cxt.depoDoc('depoLink')},
            shrink: false,
            size: {sm4: true, xs6: true},
            if: (model, field) => (model['depoLinkAction'] == null) && (model['depoLink'] == null)
          },
          {
            fieldType: 'v-flex',
            slot: 'Подготовка документа еще не завершена!',
            shrink: false,
            size: {sm8: true, xs6: true},
            if: (model, field) => model['depoLinkAction']
          },
          {
            fieldType: 'v-btn',
            slot: 'Обновить',
            events: {'click': () => cxt.refreshData()},
            shrink: false,
            size: {sm4: true, xs6: true},
            if: (model, field) => model['depoLinkAction']
          },
          {
            fieldType: 'v-flex',
            slot: 'Теперь Вы можете открыть документ в депозитарии и при необходимости изменить его',
            shrink: false,
            size: {sm8: true, xs6: true},
            if: (model, field) => !model['depoLinkAction'] && model['depoLink'] && formats.isDepoUid(model['depoLink'])
          },
          {
            fieldType: 'v-btn',
            slot: 'Открыть',
            events: {'click': () => cxt.openDoc('depoLink')},
            size: {sm4: true, xs6: true},
            if: (model, field) => !model['depoLinkAction'] && model['depoLink'] && formats.isDepoUid(model['depoLink'])
          },
          {
            fieldType: 'v-flex',
            slot: 'Вы можете подготовить новую версию документа и поместить в депозитарий. ' +
            'Важно! Если Вы уже отправляли ссылки на документ, то адресаты будут видеть старую и новую версии',
            shrink: false,
            size: {sm8: true, xs6: true},
            if: (model, field) => model['depoLink'] != null
          },
          {
            fieldType: 'v-btn',
            slot: 'Новая версия',
            events: {'click': () => cxt.depoDoc('depoLink')},
            shrink: false,
            size: {sm4: true, xs6: true},
            if: (model, field) => model['depoLink'] != null
          }
        ]
      },
      {
        depoLink: null
      })
    this.context = cxt
    this.nextEnabled = () => this.model.depoLink
  }
  fillSubTitle (model, fields) {
    return model.depoLink ? `<a href="${this.context.getDepoUrl(model.depoLink).concat('/stream')}" target="_blank">Открыть</a>` : ''
  }
}

class Strategy extends AssistClasses.Strategy {
  getTypeCode () {
    return 'CONTRACTOR_CHECK'
  }
  next (model, step) {
    const cb = (model) => {
      var currentStep = step.number
      currentStep = currentStep <= this.steps.length ? currentStep + 1 : this.steps.length + 1
      model.setCurrentStep(currentStep)
      this.context.updateData(model)
      return model
    }
    return step && step.next ? step.next(model, cb) : model
  }
  getCurrentStep (model) {
    return this.steps.find(step => step.number === model.getCurrentStep())
  }
  back (model, step) {
    const cb = (model) => {
      var currentStep = step.number
      if (currentStep > 1) {
        currentStep = currentStep - 1
        model.setCurrentStep(currentStep)
        this.context.updateData(model)
      } else {
        this.context.refreshData()
      }
      return model
    }
    return step && step.back ? step.back(model, cb) : model
  }

  complete (model, step) {
    return step && model && model.getCurrentStep() > step.number
  }

  editable (model, step) {
    return step.editable || (model && model.getCurrentStep() === step.number)
  }

  updateSteps (scheme) {
    var steps = []
    var cxt = this.context
    Object.assign(new ContractorCheckSelectContractor(cxt), {backLabel: () => 'Отмена'})
    .addToArray(steps)
    new ContractorCheckLoadDocuments(cxt)
    .fillFields()
    .addToArray(steps)
    if (scheme && scheme.steps && scheme.steps.length > 0) {
      new ContractorCheckAttachDocuments(cxt)
      .fillFields(scheme.steps[0].fields)
      .addToArray(steps)
      new ContractorCheckConfirmation(cxt)
      .fillFields(scheme.steps[0].fields)
      .addToArray(steps)
      new DocumnentCheck(cxt)
      .addToArray(steps)
    }

    this.steps = steps
    return this
  }
  updateModel (model) {
    // console.log('updateModel', model)
    this.steps.forEach((step) => step.setModel(model))
  }
  createModel () {
    var model = new Model()
    if (this.context) {
      model['companyInn'] = this.context.profile.clientInn
    }
    this.steps.forEach((step) => Object.assign(model, step.model))
    return model
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

class Model extends AssistClasses.Model {
  constructor () {
    super()
    // this.companyInn = null
    this.deedNumber = null
    this.contractorInn = null
  }

  copy () {
    return Object.assign(new Model(), this)
  }

}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/assist/ContractorCheckSteps.js